import clientConfig from '../../clientConfig';

export const isAuthorizationServiceEnabled = (tenantId: string): boolean => {
  return !!clientConfig.api.services.AAAService[tenantId]?.enabled;
};
